const WebsiteIcon = ({ height }) => {
  return (
    <svg height={height} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#fff"
        d="M29,0H3A3,3,0,0,0,0,3V25a3,3,0,0,0,3,3H6a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1V8H30V25a1,1,0,0,1-1,1H25a1,1,0,0,0,0,2h4a3,3,0,0,0,3-3V3A3,3,0,0,0,29,0ZM2,6V3A1,1,0,0,1,3,2H29a1,1,0,0,1,1,1V6Z"
      />
      <path fill="#fff" d="M27,12H25a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z" />
      <path fill="#fff" d="M7,16H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z" />
      <path fill="#fff" d="M7,12H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z" />
      <path
        fill="#fff"
        d="M23,22.54A4.55,4.55,0,0,0,18.46,18a4.49,4.49,0,0,0-3.2,1.33l-4.93,4.93A4.54,4.54,0,0,0,13.53,32h0a4.49,4.49,0,0,0,3.2-1.33l2.46-2.46h0l2.46-2.46A4.47,4.47,0,0,0,23,22.54Zm-7.67,6.72a2.52,2.52,0,0,1-1.79.74h0a2.54,2.54,0,0,1-1.79-4.33l1.76-1.75,3.58,3.58ZM21,22.54a2.56,2.56,0,0,1-.74,1.79L18.5,26.09,14.91,22.5l1.76-1.76A2.54,2.54,0,0,1,21,22.54Z"
      />
    </svg>
  );
};

export default WebsiteIcon;
